import Obtem from '../Obtem';
import type { Perfil, PerfilDaApi } from './tipos';

/**
 * Classe para requisição GET /perfis da `api-pessoas`.
 * Retorna uma lista de objetos com id e apelido de um dado perfil. 
 */
export default class ObtemListaDePerfis extends Obtem<Perfil[]> {
  protected readonly URLBase: string = process.env.REACT_APP_API_PESSOAS ?? ''; // eslint-disable-line
  protected readonly rota: string;

  constructor(token: string, parametros: URLSearchParams) {
    super(token);
    this.rota = this.definirRota(parametros);
  }

  protected definirRota(parametros: URLSearchParams): string {
    const parametrosDeBusca = parametros.toString();
    return this.URLBase + `/perfis?${parametrosDeBusca}`;
  }

  public async resultado(): Promise<Perfil[]> {
    try {
      const { data, status } = await this.conexao.get<PerfilDaApi[]>(this.rota);
      if (status === 200) {
        return data.map(({ idPerfil, apelido }) => ({
          idPerfil,
          apelido,
        }));
      }
    } catch (error) {
      console.error(error);
    }
    return [];
  }

  // Se for necessário manter os ambientes consistentes, adicionar este código
  // const URLBase = this.conexao.defaults.baseURL;
  // if (URLBase?.includes('localhost') || URLBase?.includes('homologacao')) {
  //   return 'https://api-enderecos-develop.rj.r.appspot.com/';
  // }
  // return 'https://api-enderecos-production.rj.r.appspot.com/';
}